import Layout from "../Layout";
import Footer from "../../components/Footer";
import LoginContainer from "../../containers/LoginContainer";
import GeneralHeader from "../../components/GeneralHeader";

const LoginPage = () => {
  return (
    <Layout
      header={<GeneralHeader />}
      center={<LoginContainer />}
      footer={<Footer />}
    />
  );
}

export default LoginPage;